module.exports = __webpack_public_path__ + "img/a6.be973086.jpg";